// @copyright  2025 West Indies Software Engineering Company Limited. All rights reserved.

export default [
    {
        path: '/:organisation/accounting/deferred-revenues',
        component: () =>
            import('@/pages/[organisation]/accounting/deferred-revenues.vue'),
        name: 'accounting.deferred-revenues.search-deferred-revenues',
        meta: {
            loginRequired: true,
            permission: 'access.accounting.deferred-revenue.view-deferred-revenues',
        },

        children: [
            {
                path: 'new',
                component: () =>
                    import('@/pages/[organisation]/accounting/deferred-revenues/new.vue'),
                name: 'accounting.deferred-revenues.create-deferred-revenue',
                meta: {
                    loginRequired: true,
                    permission: 'access.accounting.deferred-revenue.create-deferred-revenue',
                },
            },
            {
                path: ':id',
                component: () =>
                    import('@/pages/[organisation]/accounting/deferred-revenues/[id].vue'),
                name: 'accounting.deferred-revenues.view-deferred-revenue',
                meta: {
                    loginRequired: true,
                    permission: 'access.accounting.deferred-revenue.view-deferred-revenues',
                },
            },
            {
                path: ':id/edit',
                component: () =>
                    import('@/pages/[organisation]/accounting/deferred-revenues/[id]/edit.vue'),
                name: 'accounting.deferred-revenues.update-deferred-revenue',
                meta: {
                    loginRequired: true,
                    permission: 'access.accounting.deferred-revenue.update-deferred-revenue',
                },
            },
        ],
    },
];
